import { AnyStore, BooleanStore } from 'stores';

import { ChangeDistanceModalData } from '../types';

export const openChangeDistanceModalStore = new BooleanStore();
export const changeDistanceModalStore = new AnyStore<ChangeDistanceModalData>();
